
import filters from './utils/helper';

export default {
  install(Vue, options) {


    Vue.prototype.$helper = filters;


    Vue.prototype.$helper.formatter_money = (row, column, cellValue, index) => {
      return filters.money(cellValue);
    };

    Vue.prototype.$helper.formatter_date = (row, column, cellValue, index) => {
      return filters.date(cellValue);
    };

  }
}
